import React from 'react';
import ImageFullView from './ImageFullview';
export const ImageFullViewWrapper = (props)=>{
    return /*#__PURE__*/ React.createElement(ImageFullView, props);
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;

//# sourceMappingURL=index.js.map